import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PrepareGuard, PendingChangesGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { DealerSearchComponent } from './dealer-search/dealer-search.component';
import { DealerDetailComponent } from './dealer-detail/dealer-detail.component';
import { DealerEntryComponent } from './dealer-entry/dealer-entry.component';
import { DealerEntryDialogComponent } from './dealer-entry-dialog/dealer-entry-dialog.component';
import { PaymentCreditDialogComponent } from './payment-credit-dialog/payment-credit-dialog.component';
import { BulkEditDialogComponent } from './bulk-edit-dialog/bulk-edit-dialog.component';
import { DealerNotesComponent } from './dealer-notes/dealer-notes.component';
import { DealerNoteDialogComponent } from './dealer-note-dialog/dealer-note-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'dealers',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    { path: 'overview', component: DealerSearchComponent, data: { title: 'Dealers' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'entry', component: DealerEntryComponent, data: { title: 'Dealer Entry' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'overview/:id', component: DealerDetailComponent, data: { title: 'Dealer Detail' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'bulk-edit', component: BulkEditDialogComponent, data: { title: 'Bulk Edit' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'notes', component: DealerNotesComponent, data: { title: 'Dealer Notes' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        DealerSearchComponent, DealerDetailComponent, DealerEntryComponent, DealerEntryDialogComponent, PaymentCreditDialogComponent, BulkEditDialogComponent, DealerNotesComponent, DealerNoteDialogComponent
    ]
})
export class DealersModule {}
